import {
  Demo,
  Discovery,
  MainSongList,
  Login,
  Register,
  ResetPassword,
  SongDetailsContainer,
  AIMusicGenerator,
  EmailConfirmation,
} from 'pages';
import { PlayerLayout, NoFooterLayout, HiddenTopBarAndFooter } from 'layouts';
import { SongDetailsRedirect } from 'pages/SongDetails';
import Logout from 'pages/Login/Logout';
import { makeRoute } from './helpers/makeRoute';
import { DevOnly } from './middlewares';
import { locations } from './locations';

export default [
  makeRoute({
    path: locations.general.demo.pathname,
    component: Demo,
    middlewares: [DevOnly],
    layout: PlayerLayout,
  }),
  makeRoute({
    path: locations.general.discovery.pathname,
    component: Discovery,

    middlewares: [],
    layout: PlayerLayout,
  }),
  makeRoute({
    path: locations.general.songList.pathname,
    component: MainSongList,

    middlewares: [],
    layout: PlayerLayout,
  }),
  makeRoute({
    path: locations.general.oldSongDetails.route,
    component: SongDetailsRedirect,

    middlewares: [],
  }),
  makeRoute({
    path: locations.general.songDetails.route,
    component: SongDetailsContainer,

    middlewares: [],
    layout: NoFooterLayout,
  }),
  makeRoute({
    path: locations.general.login.pathname,
    component: Login,

    middlewares: [],
    layout: HiddenTopBarAndFooter,
  }),
  makeRoute({
    path: locations.general.logout.pathname,
    component: Logout,

    middlewares: [],
  }),
  makeRoute({
    path: locations.general.register.pathname(''),
    component: Register,

    middlewares: [],
    layout: HiddenTopBarAndFooter,
  }),
  makeRoute({
    path: locations.general.passwordReset.pathname,
    component: ResetPassword,

    middlewares: [],
    layout: HiddenTopBarAndFooter,
  }),
  makeRoute({
    path: locations.general.emailConfirmation.route,
    component: EmailConfirmation,

    middlewares: [],
  }),
  makeRoute({
    path: locations.general.aiMusicGenerator.pathname,
    component: AIMusicGenerator,

    middlewares: [],
    layout: NoFooterLayout,
  }),
];
